import { Alpha2ColorFilter } from "../../../operations/filters/alpha2Color.js";
import { GLProgram } from "../../../program.js";
export class Alpha2ColorProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var common_source = templates.get('photoshop/GL/shaders/common.glsl');
        var vertex_source = templates.get('photoshop/GL/shaders/filters/alpha2Color/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/filters/alpha2Color/fragment.glsl');
        var result = new Alpha2ColorProgram(gl, vertex_source, common_source + fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['use_selection'] = gl.getUniformLocation(result._program, 'u_use_selection');
        result._uniforms['selection_mask'] = gl.getUniformLocation(result._program, 'u_selection_mask');
        result._uniforms['color'] = gl.getUniformLocation(result._program, 'u_color');
        return result;
    }

    setUniforms(parameters: Alpha2ColorFilter) {
        var self = this;
        self._gl.uniform4fv(self.uniformLocation('color'), parameters.color);
    }

}